export interface ArticleDetail {
  slug: string;
  title: string;
  excerpt: string;
  contentHtml: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  authorName: string;
  authorAvatar: string;
  date: string;
  readCount: number;
  commentCount: number;
  tags: string[];
}

export const articleDetails: Record<string, ArticleDetail> = {
  "wanghong-fanche-zhibo-jianjia": {
    slug: "wanghong-fanche-zhibo-jianjia",
    title: "千万粉丝网红直播翻车：假货风波持续发酵，品牌方连夜解约",
    excerpt: "拥有超过两千万粉丝的头部带货主播\"小美酱\"在昨晚直播中被网友实锤售卖假冒名牌护肤品，涉事品牌已紧急发布声明终止合作。这是本月第三起头部主播翻车事件，引发全网热议。",
    contentHtml: `<p>7月6日晚间，拥有超过两千万粉丝的头部带货主播"小美酱"在例行直播中遭遇了职业生涯最大的一次翻车事件。在当晚推荐一款宣称"专柜正品"的国际知名品牌精华液时，直播间弹幕突然被大量质疑信息刷屏。</p>
    <p>多位购买了同款产品的网友在弹幕中指出，该产品从包装印刷到瓶身材质都与专柜正品存在明显差异。更有网友直接晒出对比照片，实锤该产品为假冒伪劣商品。面对汹涌的质疑声，主播"小美酱"当场慌乱解释称"这是品牌方寄来的样品"，但这一说辞并未平息争议。</p>
    <h2>品牌方连夜发布解约声明</h2>
    <p>事件发酵短短数小时后，涉事国际品牌的中国区官方账号于7月7日凌晨紧急发布声明，明确表示：该品牌从未与主播"小美酱"及其所属MCN机构有过任何形式的合作，所涉产品为假冒商品，品牌方已向市场监管部门举报并将保留追究法律责任的权利。</p>
    <p>与此同时，多位曾与"小美酱"合作的品牌方也纷纷发布声明切割关系。据不完全统计，截至发稿前已有超过15个品牌公开宣布终止与该主播的一切商业合作。</p>
    <h2>本月第三起头部主播翻车事件</h2>
    <p>值得注意的是，这已是本月内第三起头部带货主播的翻车事件。7月2日，拥有八百万粉丝的主播"大龙哥"因虚假宣传保健食品功效被市场监管局立案调查；7月4日，美妆主播"雪梨妈咪"因售卖临期化妆品且未标注生产日期被消费者集体投诉。</p>
    <p>行业分析人士指出，直播带货行业的野蛮生长阶段正在走向终结。随着监管趋严和消费者维权意识提升，过去依靠流量和话术就能轻松卖货的时代已经一去不返。</p>
    <h2>消费者维权路径梳理</h2>
    <p>对于已购买涉事产品的消费者，法律专家建议保留完整的购买凭证、直播录屏和产品实物，可以通过以下途径维权：向直播平台投诉举报、向市场监管部门投诉、向人民法院提起民事诉讼。根据《消费者权益保护法》第五十五条规定，经营者提供商品或者服务有欺诈行为的，应当按照消费者的要求增加赔偿其受到的损失。</p>
    <h2>直播带货行业的信任危机</h2>
    <p>连续多起翻车事件的发生，让直播带货行业面临前所未有的信任危机。一项最新的网络调查显示，超过65%的受访者表示对直播带货的信任度有所下降，其中产品质量问题是消费者最大的担忧。</p>`,
    category: "网红翻车",
    categorySlug: "wanghong-fanche",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20scene%20with%20a%20streaming%20studio%20setup%20featuring%20ring%20lights%20and%20a%20smartphone%20on%20a%20tripod%2C%20scattered%20luxury%20cosmetic%20products%20with%20red%20warning%20elements%2C%20dark%20and%20tense%20atmosphere%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20editorial%20photojournalism%20style%2C%20high%20contrast%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20moody%20investigative%20aesthetic&width=1600&height=800&seq=article-hero-01&orientation=landscape",
    authorName: "吃瓜编辑部",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20editorial%20avatar%20icon%2C%20minimalist%20design%20with%20warm%20red%20tones%2C%20simple%20geometric%20style%2C%20news%20media%20identity%2C%20clean%20and%20modern%20aesthetic&width=80&height=80&seq=author-avatar-01&orientation=squarish",
    date: "2026-07-07",
    readCount: 1283000,
    commentCount: 56241,
    tags: ["直播翻车", "假货", "小美酱", "品牌解约", "消费者维权"],
  },
  "danghong-nanyixing-chugui": {
    slug: "danghong-nanyixing-chugui",
    title: "当红男星深夜密会神秘女子，疑似婚内出轨",
    excerpt: "某知名男演员被拍到与一名年轻女子在酒店共度三小时，其经纪团队尚未回应。网友扒出该女子身份疑似某网红。",
    contentHtml: `<p>7月6日深夜，有媒体拍到某当红一线男演员与一名年轻女子在某五星级酒店秘密会面。据目击者描述，两人先后进入酒店，在酒店内共度约三小时后分别离开。该男演员目前已婚并育有一子，其妻子同为演艺圈知名演员。</p>
    <p>消息一经曝光，立即在社交媒体引发轩然大波。相关话题迅速登上各大平台热搜榜首，阅读量在两小时内突破两亿。</p>
    <h2>神秘女子身份被扒</h2>
    <p>万能的网友很快扒出了该神秘女子的身份。据多位网友比对分析，该女子疑似为某短视频平台拥有三百万粉丝的美妆博主"橙子爱吃鱼"。通过对比该博主当天社交媒体动态中的穿搭和配饰细节，与偷拍照片中的女子高度吻合。</p>
    <p>值得注意的是，"橙子爱吃鱼"的社交账号在消息曝光后迅速设置了私密模式，所有内容均不可见。这一举动被网友解读为"此地无银三百两"。</p>
    <h2>经纪团队保持沉默</h2>
    <p>截至发稿前，该男星的经纪团队对所有媒体询问均未做出任何回应。其工作室的官方社交账号自事发后停止了所有更新。而其妻子的社交账号最新动态显示，她于7月6日下午发布了一张独自带孩子的照片，配文"静好"二字，疑似意有所指。</p>
    <h2>圈内人士爆料不断</h2>
    <p>事件持续发酵之际，多位圈内匿名人士也纷纷爆料。有自称与该男星合作过的剧组工作人员透露，该男星在剧组期间就经常深夜外出，且有多次被目击与不同女性单独相处。但这些说法目前均未得到证实。</p>
    <p>另有知情人士称，该男星与妻子的婚姻早在一年前就出现了问题，两人目前处于分居状态。如果这一说法属实，则所谓的"出轨"在道德层面上的争议或有所减弱。</p>
    <h2>品牌代言面临风险</h2>
    <p>据业内人士分析，如果该事件最终被证实，该男星可能面临严重的商业损失。目前其名下共有12个品牌代言合同，其中多个品牌为家庭友好型品牌。一旦负面新闻坐实，品牌方很可能会启动代言合同中的道德条款要求解约和赔偿。</p>`,
    category: "娱乐八卦",
    categorySlug: "yule-bagua",
    imageUrl: "https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20photography%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20subtle%20silhouettes%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20warm%20street%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20noir%20aesthetic%2C%20soft%20bokeh%20background%2C%20deep%20blues%20and%20amber%20tones%2C%20editorial%20gossip%20magazine%20vibe&width=1600&height=800&seq=article-hero-02&orientation=landscape",
    authorName: "八卦一姐",
    authorAvatar: "https://readdy.ai/api/search-image?query=Feminine%20editorial%20avatar%20icon%20in%20minimalist%20style%2C%20warm%20coral%20and%20pink%20tones%2C%20simple%20geometric%20shape%2C%20modern%20gossip%20media%20identity%2C%20clean%20aesthetic&width=80&height=80&seq=author-avatar-02&orientation=squarish",
    date: "2026-07-07",
    readCount: 2456000,
    commentCount: 89123,
    tags: ["婚内出轨", "男星", "网红", "娱乐圈丑闻", "深夜密会"],
  },
  "zhiming-zhubo-taoshui": {
    slug: "zhiming-zhubo-taoshui",
    title: "知名主播被曝偷税漏税，金额高达数千万",
    excerpt: "税务部门已介入调查，该主播名下多家公司被列入经营异常名录。据悉，其通过设立空壳公司、阴阳合同等方式逃避个人所得税。",
    contentHtml: `<p>7月6日，据权威消息源透露，某知名游戏主播因涉嫌偷税漏税正在接受税务部门的调查。初步查明，该主播在2023年至2025年期间，通过设立多家空壳公司、签订阴阳合同等方式，逃避缴纳个人所得税，涉及金额高达数千万元。</p>
    <p>该主播在游戏直播领域极具影响力，全网粉丝总量超过三千万，年收入据估算超过一亿元。然而其申报的个人所得税却与收入严重不匹配，引起了税务部门的高度关注。</p>
    <h2>复杂的避税网络</h2>
    <p>调查发现，该主播与其背后的MCN机构共同搭建了一个极其复杂的避税网络。其名下的收入被分散到位于不同地区的多家公司，这些公司大多为空壳公司，没有实际经营业务，仅用于"走账"和"过票"。</p>
    <p>此外，该主播还通过"阴阳合同"的方式，将实际收入大幅缩水。一份对外申报的合同显示其单场直播收入仅为五万元，而实际收入则高达五十万元以上。差额部分通过私人账户和第三方支付平台流转，绕过了税务机关的监管。</p>
    <h2>行业潜规则浮出水面</h2>
    <p>税务专家指出，该主播的避税手法并非个案，在直播行业具有一定普遍性。许多头部主播通过将个人收入"转化"为企业收入、利用税收洼地政策、拆分收入等多种方式降低税负。但这其中很多操作已经越过了合法税务筹划的边界，构成了偷税漏税。</p>
    <p>随着近年来税务部门对文娱领域和网络直播行业税收监管的持续加强，类似的偷税漏税案件正在被逐一查处。此前已有数位知名主播和艺人因偷税漏税被处以巨额罚款。</p>`,
    category: "社会热点",
    categorySlug: "shehui-redian",
    imageUrl: "https://readdy.ai/api/search-image?query=Corporate%20office%20scene%20with%20financial%20documents%20and%20a%20calculator%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20overhead%20lighting%20creating%20harsh%20shadows%2C%20red%20seal%20stamps%20visible%20on%20papers%2C%20tense%20investigative%20mood%2C%20warm%20and%20cool%20color%20contrast%2C%20documentary%20style%20photography%2C%20high%20detail&width=1600&height=800&seq=article-hero-03&orientation=landscape",
    authorName: "深度调查组",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20investigative%20journalism%20avatar%20icon%2C%20dark%20and%20warm%20tones%2C%20simple%20geometric%20style%2C%20serious%20news%20media%20identity%2C%20minimalist%20aesthetic&width=80&height=80&seq=author-avatar-03&orientation=squarish",
    date: "2026-07-06",
    readCount: 1987000,
    commentCount: 67234,
    tags: ["偷税漏税", "直播行业", "税务调查", "空壳公司", "阴阳合同"],
  },
  "nvtuanti-yuan-neihong": {
    slug: "nvtuanti-yuan-neihong",
    title: "女团成员直播互撕，队内矛盾全面爆发",
    excerpt: "某当红女团两名成员在直播中公开争吵，互相指责对方耍大牌、抢资源。经纪公司紧急叫停直播，但视频已被网友录屏疯传。",
    contentHtml: `<p>7月6日下午，当红女团"星耀少女"在进行日常直播互动环节时，发生了令人震惊的队内公开争吵事件。成员小七（化名）与成员阿琳（化名）在直播中因为资源分配问题发生激烈争执，最终演变为人身攻击和互相指责。</p>
    <p>争吵的导火索是小七在回答粉丝提问时暗指"有些人仗着和经纪人关系好就霸占好资源"，阿琳当即回怼"自己没实力就别怪别人抢你资源"。随后两人唇枪舌剑，互相揭露对方的"黑料"，场面一度失控。</p>
    <h2>直播事故全过程</h2>
    <p>根据录屏视频显示，起初一切正常，五位成员正在按照流程进行粉丝问答。当一位粉丝提问"团内资源分配公平吗"时，气氛骤然紧张。小七首先打破沉默，暗讽"资源分配永远是看人下菜碟"。阿琳立即反唇相讥，称"有些人只会抱怨，从不反思自己"。双方你来我往，争吵持续了近十分钟，期间其他三位成员试图劝架但无果。</p>
    <p>最终，经纪公司工作人员紧急闯入直播间关停了直播设备。但为时已晚，整个争吵过程已被数十万在线观众目睹，录屏视频迅速在全网传播。</p>
    <h2>经纪公司紧急危机公关</h2>
    <p>事发后约三小时，星耀少女所属经纪公司发布了官方声明，称直播中的争执是"为节目效果设计的剧本"，系"排练不到位导致的误会"。然而这一解释并未获得网友认可，大量评论直指公司在"睁眼说瞎话"。</p>
    <p>据业内人士透露，星耀少女队内矛盾由来已久。团队中人气较高的三位成员与另外两位成员之间在资源分配、商务合作、个人发展等方面存在长期积怨。此次直播冲突只是冰山一角。</p>`,
    category: "娱乐八卦",
    categorySlug: "yule-bagua",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20vibe%20with%20two%20contrasting%20sides%2C%20one%20side%20bright%20stage%20lights%20and%20glamorous%20atmosphere%2C%20other%20side%20dark%20backstage%20tension%2C%20music%20performance%20elements%20like%20microphones%20and%20spotlights%2C%20dramatic%20color%20contrast%20between%20warm%20gold%20and%20cool%20shadow%2C%20editorial%20entertainment%20news%20aesthetic&width=1600&height=800&seq=article-hero-04&orientation=landscape",
    authorName: "娱乐前线",
    authorAvatar: "https://readdy.ai/api/search-image?query=Vibrant%20entertainment%20news%20avatar%20icon%2C%20warm%20gold%20and%20pink%20gradient%20tones%2C%20simple%20geometric%20shape%2C%20pop%20culture%20media%20identity%2C%20modern%20clean%20aesthetic&width=80&height=80&seq=author-avatar-04&orientation=squarish",
    date: "2026-07-06",
    readCount: 1765000,
    commentCount: 78345,
    tags: ["女团内讧", "直播事故", "星耀少女", "资源分配", "危机公关"],
  },
  "wangluo-baoli-shaonian": {
    slug: "wangluo-baoli-shaonian",
    title: "网络暴力致未成年人抑郁，涉事网红账号被永久封禁",
    excerpt: "一名十四岁少年因在网络平台被某网红粉丝集体围攻，被诊断出重度抑郁。平台方已对涉事网红账号作出永久封禁处理。",
    contentHtml: `<p>近日，一起因网络暴力导致的未成年人心理健康事件引发社会广泛关注。一名来自浙江的十四岁初中生小陈（化名），因为在某社交平台对一位百万粉丝网红的一条视频发表了不同意见，遭到了该网红粉丝长达两周的集体网络暴力，最终被医院诊断为重度抑郁。</p>
    <p>据了解，小陈在该网红视频评论区留言称"这个内容有点误导人"，这一条看似中性的评论却成了噩梦的开端。该网红在直播中点名批评了小陈的评论，导致大量粉丝涌入小陈的社交账号进行辱骂、威胁和人肉搜索。</p>
    <h2>网络暴力的残酷现实</h2>
    <p>小陈的母亲李女士在接受采访时泣不成声。她表示，在遭受网络暴力的两周时间里，小陈从最初的不以为然逐渐变得沉默寡言、食欲不振、失眠焦虑。家人起初没有意识到问题的严重性，直到学校老师反映小陈在课堂上出现自残行为，才紧急带孩子就医。</p>
    <p>医院的诊断结果为重度抑郁伴有焦虑症状，目前小陈正在接受药物治疗和心理辅导，已暂时休学。</p>
    <h2>平台方的处理与争议</h2>
    <p>事件曝光后，涉事社交平台于7月5日发布公告，宣布对涉事网红的账号实施永久封禁处理。平台方面表示，该网红的行为严重违反了社区规范，利用自身影响力煽动粉丝对他人进行网络暴力，造成了严重后果。</p>
    <p>然而，这一处理结果也引发了不同的声音。一些网友认为，仅封禁账号不足以弥补受害者的伤害，平台应该承担更多的审核和管理责任。也有法律人士指出，网络暴力的组织者和积极参与者可能面临民事赔偿甚至刑事处罚。</p>`,
    category: "社会热点",
    categorySlug: "shehui-redian",
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20social%20media%20with%20harsh%20comment%20notifications%2C%20placed%20on%20a%20windowsill%20with%20rain%20drops%20on%20glass%2C%20melancholic%20and%20somber%20atmosphere%2C%20cool%20blue-gray%20tones%20with%20soft%20natural%20window%20light%2C%20emotional%20social%20commentary%20theme%2C%20cinematic%20still%20life%20composition&width=1600&height=800&seq=article-hero-05&orientation=landscape",
    authorName: "社会观察员",
    authorAvatar: "https://readdy.ai/api/search-image?query=Thoughtful%20social%20commentary%20avatar%20icon%2C%20muted%20blue-gray%20and%20warm%20tones%2C%20simple%20geometric%20design%2C%20serious%20journalism%20identity%2C%20minimalist%20modern%20aesthetic&width=80&height=80&seq=author-avatar-05&orientation=squarish",
    date: "2026-07-05",
    readCount: 2345000,
    commentCount: 91234,
    tags: ["网络暴力", "未成年人保护", "网红封禁", "心理健康", "平台责任"],
  },
};

export interface ArticleComment {
  avatar: string;
  username: string;
  content: string;
  date: string;
  likes: number;
}

export const articleComments: Record<string, ArticleComment[]> = {
  "wanghong-fanche-zhibo-jianjia": [
    {
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%2C%20neutral%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=ac-av-01&orientation=squarish",
      username: "吃瓜不嫌事大",
      content: "这个主播我早就觉得不对劲了，每次卖的货和专柜的完全不一样，终于翻车了！支持严查！整个行业都该好好整顿一下了。",
      date: "2小时前",
      likes: 12834,
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%2C%20slight%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=ac-av-02&orientation=squarish",
      username: "理性吃瓜人",
      content: "建议大家还是等官方通报出来再下结论，现在各种消息都在传，真假难辨。不过品牌方都解约了，这基本快实锤了吧。",
      date: "3小时前",
      likes: 8921,
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20glasses%2C%20thoughtful%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=ac-av-03&orientation=squarish",
      username: "八卦小能手",
      content: "品牌方都解约了，这基本实锤了吧？我现在就好奇还有多少品牌会跟着解约。这波打击不小啊，估计她以后很难再出头了。",
      date: "4小时前",
      likes: 15234,
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20with%20casual%20style%2C%20confident%20look%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=ac-av-04&orientation=squarish",
      username: "真相只有一个",
      content: "直播带货行业确实太乱了，有关部门应该出台更严格的监管措施。消费者的权益谁来保护？花钱买假货还不能维权，真的很心寒。",
      date: "5小时前",
      likes: 11023,
    },
  ],
  "danghong-nanyixing-chugui": [
    {
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=ac-av-05&orientation=squarish",
      username: "甜甜的瓜",
      content: "天呐！这也太劲爆了吧！他老婆那么漂亮了还出轨？男人果然都是一个样。坐等工作室发声明，看这次怎么洗。",
      date: "1小时前",
      likes: 23456,
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Chinese%20man%2C%20serious%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=ac-av-06&orientation=squarish",
      username: "行业观察者",
      content: "如果真如传闻所说两人早已分居，那这事就没那么简单了。娱乐圈的婚姻本来就很脆弱，外人也不好妄加评论。",
      date: "2小时前",
      likes: 8765,
    },
  ],
};

export interface RelatedArticle {
  slug: string;
  title: string;
  imageUrl: string;
  date: string;
  category: string;
  categorySlug: string;
}

export const relatedArticles: Record<string, RelatedArticle[]> = {
  "wanghong-fanche-zhibo-jianjia": [
    {
      slug: "wangluo-hongren-beipan",
      title: "网络红人被曝背后有资本操控，人设全面崩塌",
      imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20office%20with%20documents%20scattered%20on%20a%20glass%20desk%2C%20dramatic%20side%20lighting%2C%20mysterious%20and%20investigative%20mood%2C%20warm%20amber%20tones%2C%20cinematic%20composition&width=400&height=280&seq=rel-01&orientation=landscape",
      date: "2026-07-04",
      category: "网红翻车",
      categorySlug: "wanghong-fanche",
    },
    {
      slug: "daihuo-yige-baofa",
      title: "直播带货界大地震：多位大主播集体翻车",
      imageUrl: "https://readdy.ai/api/search-image?query=Multiple%20smartphones%20displaying%20live%20streaming%20interfaces%20with%20shopping%20carts%2C%20warning%20red%20accents%2C%20clean%20minimalist%20style%2C%20white%20background%20with%20hints%20of%20red&width=400&height=280&seq=rel-02&orientation=landscape",
      date: "2026-07-05",
      category: "独家爆料",
      categorySlug: "dujia-baoliao",
    },
    {
      slug: "meizhuang-bozhu-chanpin",
      title: "美妆博主推荐产品被曝含违禁成分",
      imageUrl: "https://readdy.ai/api/search-image?query=Skincare%20products%20on%20white%20marble%20with%20a%20warning%20label%2C%20laboratory%20equipment%20in%20soft%20focus%2C%20clinical%20aesthetic%20with%20cool%20white%20and%20red%20accents&width=400&height=280&seq=rel-03&orientation=landscape",
      date: "2026-07-02",
      category: "网红翻车",
      categorySlug: "wanghong-fanche",
    },
  ],
  "danghong-nanyixing-chugui": [
    {
      slug: "nvtuanti-yuan-neihong",
      title: "女团成员直播互撕，队内矛盾全面爆发",
      imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20with%20stage%20lights%20and%20backstage%20tension%2C%20dramatic%20color%20contrast%2C%20performance%20elements%2C%20editorial%20entertainment%20aesthetic&width=400&height=280&seq=rel-04&orientation=landscape",
      date: "2026-07-06",
      category: "娱乐八卦",
      categorySlug: "yule-bagua",
    },
    {
      slug: "liuliang-xiaosheng-lianai",
      title: "流量小生被曝与女粉丝秘密恋爱",
      imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20showing%20social%20media%20with%20notifications%2C%20coffee%20cup%20and%20concert%20ticket%2C%20bittersweet%20atmosphere%2C%20warm%20ambient%20lighting&width=400&height=280&seq=rel-05&orientation=landscape",
      date: "2026-06-26",
      category: "娱乐八卦",
      categorySlug: "yule-bagua",
    },
    {
      slug: "laopai-yanyuan-fuqi",
      title: "老牌演员夫妻被传婚变，双方工作室同时辟谣",
      imageUrl: "https://readdy.ai/api/search-image?query=Split%20composition%20of%20two%20luxury%20apartments%2C%20elegant%20but%20lonely%20atmosphere%2C%20evening%20lighting%2C%20cinematic%20split-screen%20aesthetic&width=400&height=280&seq=rel-06&orientation=landscape",
      date: "2026-06-29",
      category: "娱乐八卦",
      categorySlug: "yule-bagua",
    },
  ],
  default: [
    {
      slug: "wanghong-fanche-zhibo-jianjia",
      title: "千万粉丝网红直播翻车：假货风波持续发酵",
      imageUrl: "https://readdy.ai/api/search-image?query=Streaming%20studio%20with%20ring%20lights%20and%20smartphone%2C%20scattered%20cosmetics%2C%20dramatic%20lighting%2C%20warm%20amber%20tones%2C%20editorial%20breaking%20news%20style&width=400&height=280&seq=rel-d-01&orientation=landscape",
      date: "2026-07-07",
      category: "网红翻车",
      categorySlug: "wanghong-fanche",
    },
    {
      slug: "danghong-nanyixing-chugui",
      title: "当红男星深夜密会神秘女子，疑似婚内出轨",
      imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%2C%20mysterious%20silhouettes%2C%20warm%20street%20lights%2C%20cinematic%20noir%2C%20editorial%20gossip%20magazine%20aesthetic&width=400&height=280&seq=rel-d-02&orientation=landscape",
      date: "2026-07-07",
      category: "娱乐八卦",
      categorySlug: "yule-bagua",
    },
    {
      slug: "zhiming-zhubo-taoshui",
      title: "知名主播被曝偷税漏税，金额高达数千万",
      imageUrl: "https://readdy.ai/api/search-image?query=Financial%20documents%20on%20wooden%20desk%2C%20dramatic%20lighting%2C%20red%20stamps%2C%20tense%20mood%2C%20documentary%20photography%20style&width=400&height=280&seq=rel-d-03&orientation=landscape",
      date: "2026-07-06",
      category: "社会热点",
      categorySlug: "shehui-redian",
    },
  ],
};